import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUsers } from "../repositories/userRepo";

const initialState = {
  data: [],
  loading: false,
  error: null,
};
export const getUsersData = createAsyncThunk("users", async (thunkAPI) => {
  const response = await getUsers();
  return response;
});

export const usersSlice = createSlice({
  name: "users",
  initialState,
  extraReducers: {
    [getUsersData.pending]: (state) => {
      state.loading = true;
    },
    [getUsersData.fulfilled]: (state, action) => {
      state.loading = false;
      const data = [];
      action.payload.data.map((element) => {
        // data.push(Object.values(element));
        data.push([element.id, element.username, element.email, element.phone]);
      });
      state.data = data;
      //state.data= Object.values(action.payload.data);
    },
    [getUsersData.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default usersSlice.reducer;
